export default {"src":"/_next/static/media/logo.910bd79e.svg","height":73,"width":707};